"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _compose = _interopRequireDefault(require("recompose/compose"));

var _withState = _interopRequireDefault(require("recompose/withState"));

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _transformers = require("../transformers");

var _PickerDialog = _interopRequireDefault(require("./PickerDialog"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var ColorPicker = function ColorPicker(_ref) {
  var defaultValue = _ref.defaultValue,
      _onChange = _ref.onChange,
      convert = _ref.convert,
      name = _ref.name,
      id = _ref.id,
      hintText = _ref.hintText,
      placeholder = _ref.placeholder,
      floatingLabelText = _ref.floatingLabelText,
      label = _ref.label,
      TextFieldProps = _ref.TextFieldProps,
      showPicker = _ref.showPicker,
      setShowPicker = _ref.setShowPicker,
      value = _ref.value,
      setValue = _ref.setValue;
  return _react.default.createElement(_react.Fragment, null, _react.default.createElement(_TextField.default, _extends({
    name: name,
    id: id,
    value: value,
    label: floatingLabelText || label,
    placeholder: hintText || placeholder,
    onClick: function onClick() {
      return setShowPicker(true);
    },
    onChange: function onChange(e) {
      setValue(e.target.value);

      _onChange(e.target.value);
    },
    InputProps: {
      style: {
        color: value
      }
    }
  }, TextFieldProps)), showPicker && _react.default.createElement(_PickerDialog.default, {
    value: value,
    onClick: function onClick() {
      setShowPicker(false);

      _onChange(value);
    },
    onChange: function onChange(c) {
      var newValue = _transformers.converters[convert](c);

      setValue(newValue);

      _onChange(newValue);
    }
  }));
};

ColorPicker.propTypes = {
  value: _propTypes.default.string,
  onChange: _propTypes.default.func,
  convert: _propTypes.default.oneOf(Object.keys(_transformers.converters))
};
ColorPicker.defaultProps = {
  convert: _transformers.DEFAULT_CONVERTER
};
var makeColorPicker = (0, _compose.default)((0, _withState.default)('showPicker', 'setShowPicker', false), (0, _withState.default)('value', 'setValue', function (_ref2) {
  var defaultValue = _ref2.defaultValue;
  return defaultValue;
}));

var _default = makeColorPicker(ColorPicker);

exports.default = _default;